import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import './SiteHeader.css';

/**
 * Gemeinsamer fixer Header für statische/öffentliche Seiten
 * (Impressum, Datenschutz, …) im Stil des Landing-Headers.
 */
const SiteHeader: React.FC = () => {
  return (
    <header className="site-header">
      <div className="site-header-inner">
        <Link to="/" aria-label="ELFHALBE — zur Startseite">
          <BrandLogo height={18} withIcon />
        </Link>
        <nav className="site-header-nav">
          <Link to="/">Zur Startseite</Link>
          <Link to="/login" className="site-header-login">
            Login
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default SiteHeader;
